<stx-page-header [pageTitleKey]="pageTitleKey" [name]="name" [localName]="localName"></stx-page-header>
<ng-content></ng-content>
